import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { Form } from "antd";

const Sid = ({ data }) => {
  return (
    <Form labelAlign="left" key={data?.transactionId}>
      <StyledGridRow gutter={20}>
        <StyledGridCol lg={8}>
          <FormItem label="SID">
            <TextField value={data?.stateId ?? ""} readOnly />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={8}>
          <FormItem label="ORI">
            <TextField value={data?.oriId ?? ""} readOnly />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={8}>
          <FormItem label="FBI #">
            <TextField value={data?.fbiNumber ?? ""} readOnly />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>
    </Form>
  );
};

export default Sid;
